import { render } from "./Item2.vue?vue&type=template&id=f5bfc192"
import script from "./Item2.vue?vue&type=script&lang=ts"
export * from "./Item2.vue?vue&type=script&lang=ts"
script.render = render

export default script